<template>
  <ModalTemplate
    :isOpen="isOpen"
    :on-close="onClose"
    :modalMainContainerClass="'event_details_modal'"
    :title="$t('UPCOMMING_CALENDAR.DETAILS_MODAL.TITLE')"
  >
  <div v-if="event.extendedProps">
    <div class="mt_20 info_row">
        <div>
            <fluent-icon icon="checkbox_indeterminate" />
        </div>
        <div>
            <h3 class="font_regular font_700 text_14">{{event.title}}</h3>
            <p class="font_regular font_400 text_12">{{formattedDateTime}}</p>
            <p class="font_regular font_400 text_12">{{event.extendedProps.timezone}}</p>
            <p class="font_regular font_400 text_12">{{event.extendedProps.description}}</p>
        </div>
    </div>
    <div class="mt_20 info_row">
        <div>
            <fluent-icon icon="calendar-clock" />
        </div>
        <div>
            <p class="font_regular font_400 text_12">{{event.extendedProps.totalTime}} {{$t('UPCOMMING_CALENDAR.DETAILS_MODAL.BODY.DURATION')}}</p>
        </div>
    </div>
    <div class="mt_20 info_row">
        <div>
            <fluent-icon icon="video-call" />
        </div>
        <div>
            <div v-if="event.extendedProps.meeting_session.location.type === 'google_meet'">
              <a class="meet_btn" :href="event.extendedProps.location" target="_blank">{{$t('UPCOMMING_CALENDAR.DETAILS_MODAL.BODY.JOIN_BTN')}}</a>
            </div>
            <div v-else>
              <p class="font_regular font_400 text_12">{{event.extendedProps.meeting_session.location.custom}}</p>
            </div>
        </div>
    </div>
    <div class="mt_20 info_row">
        <div>
            <fluent-icon icon="people" />
        </div>
        <div>
            <p class="font_regular font_600 text_12">{{event.extendedProps.attendees.length}} {{$t('UPCOMMING_CALENDAR.DETAILS_MODAL.BODY.ATTENDEES')}}</p>
            <ul class="mt_2" style="list-style: none;">
                <li v-for="attendee in event.extendedProps.attendees" class="attendee my_1" :key="attendee.id">
                    <p class="font_regular font_400 text_12">{{attendee.name}}</p>
                    <p class="font_regular font_400 text_12 text_black_secondary">{{attendee.email}}</p>
                    <p class="font_regular font_400 text_12 text_black_secondary">{{attendee.phone_number}}</p>
                    <div class="attendee_btns">
                      <woot-button
                        class="new-message"
                        icon="chat"
                        size="small"
                        @click="onAttendeeChatClick(attendee)"
                      />
                      <woot-button
                        class="merge-contact"
                        variant="smooth"
                        color-scheme="secondary"
                        icon="person"
                        size="small"
                        @click="onAttendeeInfoClick(attendee)"
                      />
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="mt_20 info_row">
        <div>
            <fluent-icon icon="calendar-check" />
        </div>
        <div>
            <p class="font_regular font_600 text_12">{{event.extendedProps.user.name}}</p>
            <p class="font_regular font_400 text_12">{{event.extendedProps.user.email}}</p>
        </div>
    </div>


    <NewConversation
      v-if="selectedAttendee"
      :show="isConversationModalOpen"
      :contact="selectedAttendee"
      @cancel="onCloseConversationModal"
    />
      <!-- @cancel="toggleConversationModal" -->

  </div>
  </ModalTemplate>
</template>

<script>
import ModalTemplate from 'dashboard/components/ModalTemplate.vue';
import moment from 'moment';
import NewConversation from '../../../dashboard/conversation/contact/NewConversation.vue'
import { mapGetters } from 'vuex';
export default {
  components: {
    ModalTemplate,
    NewConversation,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    event: {
      type: Object,
      default: () => {},
    },
  },
  data: function() {
    return {
      selectedAttendee: null,
      isConversationModalOpen: false,
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
    }),
    formattedDateTime() {
        const start = moment(this.event.startStr);
        const end = moment(this.event.endStr);

        const dayAndDate = start.format('dddd, MMMM D');
        const startTime = start.format('HH:mm');
        const endTime = end.format('HH:mm');

        return `${dayAndDate} ⋅ ${startTime} – ${endTime}`;
    },
  },
  methods: {
    async onAttendeeChatClick(attendee) {
      // get contactable inboxes and append with the attendee
      const contactableInboxes = await this.$store.dispatch('contacts/fetchContactableInbox', attendee.id);
      this.selectedAttendee = {
        ...attendee,
        contactableInboxes,
      };
      this.onOpenConversationModal();
    },
    onAttendeeInfoClick(attendee) {
      this.$router.push(`/app/accounts/${this.currentUser.account_id}/contacts/${attendee.id}`);
    },
    onOpenConversationModal() {
      this.isConversationModalOpen = true;
    },
    onCloseConversationModal() {
      this.selectedAttendee = null;
      this.isConversationModalOpen = false;
    },
    onClose() {
      this.$emit('onClose');
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';

.info_row{
    display: grid;
    grid-template-columns: 30px 1fr;
    gap: 1rem;
}
.meet_btn{
    background: #8D25F6;
    color: #fff;
    border-radius: 10px;
    padding: 10px 20px;
}

.attendee{
  position: relative;
  .attendee_btns{
    position: absolute;
    top: 0;
    right: 0;
  }
}
</style>
<style>
.event_details_modal{
    width: 40rem;
}
</style>